import React from 'react';
import AppPC from './pc/App';
import SavedQuotations from './pc/SavedQuotations';

// 모든 화면 크기에서 PC 컴포넌트 사용 (반응형으로 모바일까지 커버)
export default function AppRouter() {
  if (window.location.pathname.startsWith('/quotations')) return <SavedQuotations />;
  return <AppPC />;
}
